import { EntityModel } from '@/interfaces'
import {
  ALL_ITINERARIES_QUERY,
  CREATE_ITINERARY_MUTATION,
  DELETE_ITINERARY_MUTATION,
  FORCE_DELETE_ITINERARY_MUTATION,
  SINGLE_ITINERARY_QUERY,
  UPDATE_ITINERARY_MUTATION,
} from './graphql'
import itineraryItemEntity from '@/entities/itineraryItem/entity'

const itineraryModel: EntityModel = {
  name: 'itinerary',
  namePlural: 'itineraries',
  uniqueName: 'itinerary',
  uniqueNamePlural: 'itineraries',
  path: 'travel/itinerary/itinerary',
  baseUrl: '/travel/itinerary/itineraries',
  translationPrefix: 'entities:itinerary.',
  getDisplayName: (values: any) => {
    return 'Itinerary'
  },
  gql: {
    getAll: ALL_ITINERARIES_QUERY,
    getSingle: SINGLE_ITINERARY_QUERY,
    create: CREATE_ITINERARY_MUTATION,
    update: UPDATE_ITINERARY_MUTATION,
    delete: DELETE_ITINERARY_MUTATION,
    forceDelete: FORCE_DELETE_ITINERARY_MUTATION,
  },
  attributes: {
    items: {
      name: 'items',
      label: 'entities:itinerary.attributes.items.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return itineraryItemEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
  },
}

export default itineraryModel
